import { Pressed } from '../Pressed';
import { CSSObject, styled } from '../styled';

import { SwitchProps } from './types';

export const Container = styled(Pressed)<SwitchProps>(({ theme }) => ({
  backgroundColor: theme.palette.switchBg,
  borderRadius: 14,
  minWidth: 32,
  maxWidth: 32,
  minHeight: 20,
  maxHeight: 20,
  padding: 4,
  alignItems: 'center',

  cursor: 'pointer',
  '&.disabled': {
    cursor: 'default',
    backgroundColor: theme.palette.switchDisabledBg,
  },

  '&:hover': {
    outline: `4px solid ${theme.palette.switchHoverBorder}`,
  } as CSSObject,

  '& .switch-thumbContainer': {
    width: 12,
    height: 12,
    transitionDuration: '300ms',
    transitionProperty: 'transform',
    color: theme.palette.switchThumb,

    '& .switch-thumb': {
      backgroundColor: 'currentColor',
      width: '100%',
      height: '100%',
      borderRadius: '100%',
    },
  },

  '&.checked': {
    backgroundColor: theme.palette.switchBgChecked,
  },

  '&.checked .switch-thumbContainer': {
    color: theme.palette.switchThumbChecked,
    transform: `translateX(${20 - 8}px)`,
  } as CSSObject,

  '&.disabled .switch-thumbContainer': {
    color: theme.palette.switchDisabledThumb,
  },
}));
